'use strict';

export class Header {

    #add_team_campaign_to_cart_button;
    #add_team_campaign_to_cart_form;

    constructor() {
        this.#add_team_campaign_to_cart_button = document.querySelector('.add-team-campaign-to-cart');
        this.#add_team_campaign_to_cart_form = document.querySelector('form.add_campaign_to_cart');

        this.addEvents();
		this.addP2PBackToCampaignsButton()
    }

    addEvents(){
        if(this.#add_team_campaign_to_cart_form){
            document.addEventListener('click', (event)=>{
               if(event.target.matches('.add-team-campaign-to-cart') || event.target.closest('.add-team-campaign-to-cart')) {
                   event.preventDefault();
                   let form_submit_button = this.#add_team_campaign_to_cart_form.querySelector('button[type="submit"]');
                   if(form_submit_button){
                       form_submit_button.click();
                   }
               }
            });
        }
    }

	addP2PBackToCampaignsButton(){
		const logobox_in_header = document.querySelector('header > section > div > div:first-child')

		if(![...document.body.classList].includes('product-type-p2p-campaign') || !logobox_in_header) return

		logobox_in_header.style.cssText = `
			display: flex;
			align-items: center;
			gap: 20px;
			flex-basis: auto;
		`

		// link should be amended from theme js, done for uh
		logobox_in_header.innerHTML += `<a href='${location.origin}/' class='link_to_all_p2ps'>Back to all My Mitzvah campaigns</a>`
	}
}
